import { Routes } from '@angular/router';

import { BILLING_ROUTES } from '@features/settings/billing/billing.routes';
import { subscriptionLevelGuard } from '@features/settings/billing/guards/subscription-level.guard';
import { subscriptionGuard } from '@features/settings/billing/guards/subscription.guard';
import { USERS_ROUTES } from '@features/settings/users/users.routes';
import { SETTINGS_SLUGS } from '@routes/routes.types';
import { subscriptionCompletedGuard } from './billing/guards/subscription-completed.guard';
import { DEPARTMENTS_ROUTE } from './departments/departments.routes';

import { apiAccessGuard } from './api-keys/api-access.guard';
import { settingsAdminGuard } from './settings-admin.guard';

export const SETTINGS_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: SETTINGS_SLUGS.account,
    },
    {
        path: '',
        loadComponent: () =>
            import('@features/settings/settings.component').then(m => m.SettingsComponent),
        children: [
            DEPARTMENTS_ROUTE,
            {
                path: SETTINGS_SLUGS.account,
                title: 'Account',
                loadComponent: () =>
                    import('./account/account.component').then(m => m.AccountComponent),
                canActivate: [subscriptionGuard],
            },
            {
                path: SETTINGS_SLUGS.apiKeys,
                title: 'API keys',
                loadComponent: () =>
                    import('./api-keys/api-keys-page/api-keys-page.component').then(
                        m => m.ApiKeysPageComponent
                    ),
                canActivate: [subscriptionGuard, apiAccessGuard],
            },
            {
                path: SETTINGS_SLUGS.webhooks,
                title: 'Webhooks',
                loadComponent: () =>
                    import('./webhooks/webhooks-page/webhooks-page.component').then(
                        m => m.WebhooksPageComponent
                    ),
                canActivate: [subscriptionGuard, apiAccessGuard],
            },
            {
                path: SETTINGS_SLUGS.cancel,
                title: 'Cancel plan',
                loadComponent: () =>
                    import(
                        '@features/settings/cancel-subscript-page/cancel-subscript-page.component'
                    ).then(m => m.CancelSubscriptPageComponent),
            },
            {
                path: SETTINGS_SLUGS.billing,
                children: BILLING_ROUTES,
            },
        ],
    },
];
